import React from 'react';
import i18n from '../../../i18n/i18n';

import LazyImage from '../../../components/LazyImage';

import residentialBuildingImg from "../../../images/bulkListing/residential-building.png";
import commercialBuildingImg from "../../../images/bulkListing/commercial-building.png";
import airbnbManagementImg from "../../../images/bulkListing/airbnb-management.png";
import developerImg from "../../../images/bulkListing/developer.png";

const partnersList = [
  {
    title: i18n.t("bulkListing.carparkPartnersBanner.residentialBuilding.title"),
    description: i18n.t("bulkListing.carparkPartnersBanner.residentialBuilding.description"),
    resolution: i18n.t("bulkListing.carparkPartnersBanner.residentialBuilding.resolution"),
    image: residentialBuildingImg,
    color: "bg-gradient-to-r from-[#227C97] to-[#45B0B6]",
    align: "left",
    alt: "residential-building-img"
  },
  {
    title: i18n.t("bulkListing.carparkPartnersBanner.commercialBuilding.title"),
    description: i18n.t("bulkListing.carparkPartnersBanner.commercialBuilding.description"),
    resolution: i18n.t("bulkListing.carparkPartnersBanner.commercialBuilding.resolution"),
    image: commercialBuildingImg,
    color: "bg-gradient-to-r from-[#272424] to-[#033C59]",
    align: "right",
    alt: "commercial-building-img"
  },
  {
    title: i18n.t("bulkListing.carparkPartnersBanner.airbnb.title"),
    description: i18n.t("bulkListing.carparkPartnersBanner.airbnb.description"),
    resolution: i18n.t("bulkListing.carparkPartnersBanner.airbnb.resolution"),
    image: airbnbManagementImg,
    color: "bg-gradient-to-r from-[#D93C61] to-[#E5666B]",
    align: "left",
    alt: "airbnb-management-img"
  },
  {
    title: i18n.t("bulkListing.carparkPartnersBanner.developer.title"),
    description: i18n.t("bulkListing.carparkPartnersBanner.developer.description"),
    resolution: i18n.t("bulkListing.carparkPartnersBanner.developer.resolution"),
    image: developerImg,
    color: "bg-gradient-to-r from-[#E37900] to-[#FFA12B]",
    align: "right",
    alt: "developer-img"
  },
];

const CarparkPartnersBanner = () => {
  return (
    <div className="w-full bg-white p-[25px] md:py-[50px] md:px-[70px] lg:py-[30px] lg:px-[100px] xl:px-[200px] 2xl:px-[300px]">
      <div className="flex flex-col items-center my-[15px]">
        <div className="text-[15px] text-black font-bold text-center md:text-[20px]">{i18n.t("bulkListing.carparkPartnersBanner.title")}</div>
        <div className="flex flex-col items-center mt-[15px]">
          {partnersList.map((partner, index) => (
            <div className={`${partner.color} flex flex-col my-[10px] rounded-[12px] shadow-[1px_1px_5px_1px_rgba(0,0,0,0.2)] lg:flex-row`} key={`partner-${index}`}>
              {partner.align === "left" && <LazyImage className="w-[100%] rounded-[8px] object-cover lg:w-[45%] lg:rounded-[0px]" src={partner.image} alt={partner.alt} />}
              <div className="flex flex-col px-[30px] py-[25px]">
                <div className="text-white text-[13px] font-bold md:text-[15px]">{partner.title}</div>
                <div className="mt-[15px] text-white text-[11px] md:text-[12px]">{partner.description}</div>
                <div className="mt-[15px] text-white text-[11px] md:text-[12px]">{partner.resolution}</div>
              </div>
              {partner.align === "right" && <LazyImage className="w-[100%] rounded-[8px] object-cover lg:w-[45%] lg:rounded-[0px]" src={partner.image} alt={partner.alt} />}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CarparkPartnersBanner;